import { Injectable } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import { Role } from "./roles";

@Injectable()
export class UserRoleService {

    constructor(private jwtHelperService: JwtHelperService) {
    }

    public hasRoles(roles: Role[]): boolean {
        const token = localStorage.getItem("isp-app.token");

        if (token) {
            const user = this.jwtHelperService.decodeToken(token);

            if (user && user.roles) {
                return roles.some((role) => user.roles.includes(role));
            }
        }

        return false;
    }

    public fullUser(): boolean {
        const token = localStorage.getItem("isp-app.token");

        if (token) {
            const user = this.jwtHelperService.decodeToken(token);

            if (user) {
                return user;
            }
        }

        return false;
    }
}
